/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetMedicalHistoryErrorResponse, MedicalHistory } from './api.schemas';

import { api } from '../util/http';

export const getEncountersMedicalHistory = (encounterId: number, signal?: AbortSignal) => {
  return api<MedicalHistory>({
    url: `/api/encounters/${encounterId}/medical-history`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersMedicalHistoryQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/medical-history`] as const;
};

export const getGetEncountersMedicalHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
  TError = GetMedicalHistoryErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalHistory>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersMedicalHistoryQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersMedicalHistory>>> = ({
    signal,
  }) => getEncountersMedicalHistory(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersMedicalHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersMedicalHistory>>
>;
export type GetEncountersMedicalHistoryQueryError = GetMedicalHistoryErrorResponse;

export function useGetEncountersMedicalHistory<
  TData = Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
  TError = GetMedicalHistoryErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
          TError,
          Awaited<ReturnType<typeof getEncountersMedicalHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersMedicalHistory<
  TData = Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
  TError = GetMedicalHistoryErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
          TError,
          Awaited<ReturnType<typeof getEncountersMedicalHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersMedicalHistory<
  TData = Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
  TError = GetMedicalHistoryErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersMedicalHistory<
  TData = Awaited<ReturnType<typeof getEncountersMedicalHistory>>,
  TError = GetMedicalHistoryErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMedicalHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersMedicalHistoryQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
